/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Account_Notifications_ExpiresInputs */

const he_account_notifications_expires = /** @type {(inputs: Account_Notifications_ExpiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`פג תוקף ב-${i?.date}`)
};

const en_account_notifications_expires = /** @type {(inputs: Account_Notifications_ExpiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Expires {date}" |
*
* @param {Account_Notifications_ExpiresInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_expires = /** @type {((inputs: Account_Notifications_ExpiresInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_ExpiresInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_expires(inputs)
	return en_account_notifications_expires(inputs)
});